export const GOOGLE_API_KEY = "AIzaSyDYfjHl41cQl4BQZZ35YKPh-sHhL0Vv2ZM";
